import React from "react";
import { ReactElement } from "react";
import { VerbouwingsSpecificatieHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../../components/Heading";
import { Paragraph } from "../../../components/Paragraph";
import Table from "../../../components/Table";
import { Column } from "../../../components/BaseTable";
import "./verbouwings-specificatie-chapter.scss";

type VerbouwingsSpecificatieProps = {
  verbouwingsspecificatie: VerbouwingsSpecificatieHoofdstuk;
};

const verbouwingTable = (
  verbouwingsspecificatie: VerbouwingsSpecificatieHoofdstuk
): ReactElement => {
  if (!verbouwingsspecificatie.verbouwingen || verbouwingsspecificatie.verbouwingen.length === 0) {
    return <></>;
  }

  // Transform data for rotation: create a single object where each verbouwing becomes a property
  const transformedData = verbouwingsspecificatie.verbouwingen.reduce((acc, verbouwing, index) => {
    // Use a safe property name based on the omschrijving or index
    const key = `verbouwing_${index}`;
    acc[key] = verbouwing.bedrag;
    return acc;
  }, {} as Record<string, any>);

  // Create columns for each verbouwing
  const columns: Column[] = verbouwingsspecificatie.verbouwingen.map((verbouwing, index) => (
    {
    header: verbouwing.omschrijving || "",
    accessor: `verbouwing_${index}`,
    dataType: "currency",
    align: "right"
  }));

  return (
    <Table 
      columns={[{
        header: "",
        accessor: () =>null,
      },...columns]} 
      data={[transformedData]} 
      filterNullAnd0Columns={false} 
      className="verbouwingen-table"
      showHeader={false}
      rotate
    />
  );
};

export const VerbouwingsSpecificatieChapter = ({
  verbouwingsspecificatie,
}: VerbouwingsSpecificatieProps): ReactElement => {
  return (
    <div className="break-avoid">
      {verbouwingsspecificatie.titel && (
        <Heading
          text={`${verbouwingsspecificatie.titel}`}
          level={2}
        />
      )}

      <Paragraph paragraaf={verbouwingsspecificatie?.paragrafen?.p3040401}></Paragraph>
      {verbouwingTable(verbouwingsspecificatie)}
    </div>
  );
};
